import { useEffect,useState } from "react";
import Swal from "sweetalert2";
import api from "../api/axios";

function AddUser() {
  const [form, setForm] = useState({
    fullName: "",
    userName: "",
    password: "",
    mobileNo: "",
    emailId: "",
    roleName: "Counter",
    counterId: "",
    isActive: true,
  });

    const [counterId, setCounterId] = useState("");

 const [counters, setCounters] = useState([]);

  useEffect(() => {
    loadCounters();
  }, []);

  const loadCounters = async () => {
    try {
      const response = await api.get("/Counter/GetCounter");
      setCounters(response.data);
    } catch (error) {
      console.error("Error loading counters:", error);
    }
  };


  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;

  //   setForm({
  //     ...form,
  //     [name]: type === "checkbox" ? checked : value,
  //   });
  // };

  const handleChange = (e) => {
  const { name, value, type, checked } = e.target;

  setForm((prev) => ({
    ...prev,
    [name]: type === "checkbox" ? checked : value,
    ...(name === "roleName" && value !== "Counter"
      ? { counterId: "" }
      : {}),
  }));
};

  const save = async (e) => {
    e.preventDefault();

if (form.roleName === "Counter" && !form.counterId) {
  Swal.fire("Error", "Please select Counter", "warning");
  return;
}

    try {
      const response = await api.post("/Login/AddUser", form);

      await Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message || "User Created Successfully",
      });
      // alert("User Created Successfully");

      setForm({
        fullName: "",
        userName: "",
        password: "",
        mobileNo: "",
        emailId: "",
        roleName: "Counter",
        counterId: "",
        isActive: true,
      });
    } catch (error) {
      //alert(err.response?.data || "Error creating user");
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.form ||
          error.response?.data?.message ||
          "Something went wrong",
      });
    }
  };

  return (
   
      <div className="card shadow">
        <div className="card-header bg-primary text-white">
          <h4 className="mb-0">Add User</h4>
        </div>

        <div className="card-body">
          <form onSubmit={save}>
            <div className="row">
              <div className="mb-3 col-md-4 col-12">
                <label>Full Name</label>

                <input
                  type="text"
                  name="fullName"
                  className="form-control"
                  value={form.fullName}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3 col-md-4 col-12">
                <label>Mobile No.</label>

                <input
                  type="text"
                  name="mobileNo"
                  className="form-control"
                  value={form.mobileNo}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3 col-md-4 col-12">
                <label>Email ID</label>

                <input
                  type="text"
                  name="emailId"
                  className="form-control"
                  value={form.emailId}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3 col-md-4 col-12">
                <label>User Name</label>

                <input
                  type="text"
                  name="userName"
                  className="form-control"
                  value={form.userName}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3 col-md-4 col-12">
                <label>Password</label>

                <input
                  type="password"
                  name="password"
                  className="form-control"
                  value={form.password}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-3 col-md-2 col-6">
                <label>Select Role</label>

                <select
                  name="roleName"
                  className="form-control"
                  value={form.roleName}
                  onChange={handleChange}
                >
                  <option value="Admin">Admin</option>

                  <option value="Counter">Counter</option>

                  <option value="Display">Display</option>
                </select>
              </div>

              {/* {form.roleName === "Counter" && (
                <div className="mb-3 col-md-2 col-6">
                  <label>Counter ID</label>

                  <input
                    type="number"
                    name="counterId"
                    className="form-control"
                    value={form.counterId}
                    onChange={handleChange}
                  />
                </div>
              )} */}

      {/* Counter Dropdown */}
      {/* {form.roleName === "Counter" && (
             <div className="mb-3 col-md-2 col-6">
              <label className="form-label">Select Counter</label>

              <select
                className="form-select"
                value={counterId}
                onChange={(e) => setCounterId(e.target.value)}
              >
                <option value="">Select Counter</option>

                {counters.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.counterName}
                  </option>
                ))}
              </select>
            </div>
 )} */}

 {form.roleName === "Counter" && (
  <div className="mb-3 col-md-2 col-6">
    <label className="form-label">Select Counter</label>

    <select
      name="counterId"
      className="form-select"
      value={form.counterId}
      onChange={handleChange}
    >
      <option value="">Select Counter</option>

      {counters.map((item) => (
        <option key={item.id} value={item.id}>
          {item.counterName}
        </option>
      ))}
    </select>
  </div>
)}
              <div className="p-3 text-center col-md-12 col-12">
                <input
                  type="checkbox"
                  name="isActive"
                  className="form-check-input"
                  checked={form.isActive}
                  onChange={handleChange}
                />
                &nbsp;<label className="form-check-label">Active</label>
              </div>
              <div className="mb-3 text-center col-12">
                <button type="submit" className="btn btn-success">
                  Save User
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
   
  );
}

export default AddUser;
